var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "publishSuccess_a",
    x1: "0%",
    x2: "101.131%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "publishSuccess_b",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#publishSuccess_a)",
    d: "M30.5 12V7.42a2 2 0 0 1 2.98-1.743l9.921 5.58a2 2 0 0 1 0 3.486l-9.901 5.57V31h-3V12zm3-2.87v7.74L40.38 13 33.5 9.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#publishSuccess_b)",
    d: "M44.475 43.997c-3.287-.04-5.54-.466-7.935-1.304-.227-.08-1.499-.546-1.835-.658-1-.335-1.771-.481-2.732-.481-.964 0-1.733.147-2.735.485-.329.112-1.575.571-1.806.653-2.381.839-4.626 1.265-7.908 1.305L6.234 58.162a1.5 1.5 0 1 1-2.188-2.053l25.395-27.066a3.5 3.5 0 0 1 5.115-.003L59.954 56.11a1.5 1.5 0 1 1-2.188 2.053l-13.29-14.165zm-2.994-3.191l-9.115-9.716c-.227-.213-.543-.202-.734.003l-9.112 9.712a18.374 18.374 0 0 0 3.915-.943c.195-.069 1.466-.538 1.843-.665 1.29-.436 2.374-.643 3.695-.643 1.314 0 2.397.205 3.684.636.385.129 1.684.604 1.874.671 1.287.45 2.513.763 3.95.945z"
  }))));
};
export default SvgSuccess;